import { FeatureAccess, Language } from './common';
import { Company } from './company';

export type UserType =
  | 'superadmin'
  | 'company_admin'
  | 'company_user'
  | 'external_user'
  | 'unknown';

export interface QuickSightDashboard {
  dashboard_id: string;
  name: string;
}

export interface QuickSight {
  embed_url: string;
  dashboards: QuickSightDashboard[];
}

export interface UserAttributes {
  email?: string;
  password?: string;
  user_type: UserType;
  last_sign_in_at: number;
  portfolios: string[];
  active: boolean;
  name: string;
  family_name: string;
  language: Language;
  external_organization: string;
  expiration_date: number;
  feature_access: FeatureAccess[];
  locked_at: number | null;
  measured_by: string;
  currency_code: string;
  quicksight_embed_url?: QuickSight;
}
export interface User {
  type: string;
  id?: number;
  attributes: UserAttributes;
  relationships?: {
    company?: Company;
  };
}

export type UserAttributesNames =
  | Extract<keyof UserAttributes, string>
  | 'company_uuid';

export const userAttributes = [
  'email',
  'password',
  'user_type',
  'last_sign_in_at',
  'portfolios',
  'active',
  'name',
  'family_name',
  'language',
  'external_organization',
  'expiration_date',
  'locked_at',
  'feature_access',
  'measured_by',
  'currency_code',
];
